module.exports = __webpack_public_path__ + "img/4.20f82a1c.png";